import { getVisibilityStage } from './shiftDailyBoard';

// Arrival still allows completion after the scheduled end; elapsed travel does not.
export function isStaleUnfinishedShift(shift, now = Date.now()) {
  const value = shift?.endTime;
  const end = value?.toMillis ? value.toMillis() : value?.toDate ? value.toDate().getTime() : new Date(value).getTime();
  return value != null && Number.isFinite(end) && end <= now &&
    !['arrived', 'completed', 'closed'].includes(getVisibilityStage(shift));
}
